var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcn24Facebook = function SvgLightIcn24Facebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m17.192 12.578.62-4.047H13.93V5.905c0-1.107.542-2.186 2.281-2.186h1.766V.273S16.374 0 14.843 0c-3.198 0-5.288 1.938-5.288 5.447V8.53H6v4.047h3.555v9.783a14.1 14.1 0 0 0 4.375 0v-9.783z",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcn24Facebook;